import { faPencil, faPlus } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, IconButton, Paper, styled, Tooltip, Typography } from '@mui/material';
import { ScopeGrid, DefaultScopeGridColumnFn, IScopeGridColumnFn, ClientConfigurationContext } from '@ngt/openiddict';
import { FC, useContext } from 'react';
import { generatePath, Link } from 'react-router-dom';

const ScopeColumnsFn: IScopeGridColumnFn = (clientConfiguration) => {
    const columns = DefaultScopeGridColumnFn(clientConfiguration)
        
    columns.push({
        field: 'actions',
        headerName: ' ',
        width: 70,
        renderCell: (params) => (
            <IconButton component={Link} to={generatePath(clientConfiguration?.administrationUris?.scope ?? '/', { id: params.row.id })} color="secondary">
                <FontAwesomeIcon icon={faPencil} size="sm" />
            </IconButton>
        )
    })

    return columns;
}

const Title = styled(Typography)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center'
}));

const ButtonBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    marginLeft: 'auto',
    marginRight: theme.spacing(2)
}));

const Scopes: FC = () => {
    const { data: clientConfiguration } = useContext(ClientConfigurationContext);

    return (
        <>
            <Title 
                variant="h1" 
                gutterBottom
            >
                Scopes
                <Tooltip title="New Scope">
                    <ButtonBox>
                        <IconButton component={Link} to={generatePath(clientConfiguration?.administrationUris?.scope ?? '/', { id: 'insert' })}>
                            <FontAwesomeIcon icon={faPlus} />
                        </IconButton>
                    </ButtonBox>
                </Tooltip>
            </Title>
            <Paper
                sx={{ 
                    height: 'calc(100vh - 178px)',
                    minHeight: '300px'
                }}
            >
                <ScopeGrid 
                    columnFn={ScopeColumnsFn} 
                />
            </Paper>
        </>
    );
}

export default Scopes;